import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import {
  getCsvExportFile,
  getCsvExportList,
  getDataSheetExportFile,
  getDataSheetExportList,
  postCsvExport,
  postDataSheetExport,
} from '../../apis/export'
import { setErrors } from '../common/errorsSlice'
import { DataSheetInfo, DataSheetList, DataSheetExportParams, CsvList, CsvInfo, CsvExportParams } from '../../types/export'

interface ExportListState {
  dataSheetList: DataSheetInfo[]
  csvList: CsvInfo[]
  isLoading: boolean
}

const initialState: ExportListState = {
  dataSheetList: [],
  csvList: [],
  isLoading: true,
}

const exportListSlice = createSlice({
  name: 'exportList',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getDataSheetExportSuccess: (state, action: PayloadAction<DataSheetList>) => {
      state.dataSheetList = action.payload.list
      state.isLoading = false
      return state
    },
    getCsvExportSuccess: (state, action: PayloadAction<CsvList>) => {
      state.csvList = action.payload.list
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getDataSheetExportSuccess,
  getCsvExportSuccess,
  requestFailure,
} = exportListSlice.actions

export const exportListReducer = exportListSlice.reducer
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileDownload = require('js-file-download')

// csv
export const fetchCsvExportList = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getCsvExportList()
    .then((result) => {
      dispatch(getCsvExportSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createCsvExport = (
  params: CsvExportParams,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postCsvExport(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const fetchCsvFile = (
  id: number,
  callback: (url: string) => void,
): AppThunk => async (dispatch) => {
  getCsvExportFile(String(id))
    .then((response) => {
      callback(response.url)
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

// dataSheet
export const fetchDataSheetExportList = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getDataSheetExportList()
    .then((result) => {
      dispatch(getDataSheetExportSuccess(result))
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createDataSheetExport = (
  params: DataSheetExportParams,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postDataSheetExport(params)
    .then(() => {
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const fetchDataSheetDownloadUrl = (
  id: number,
  callback: (url: string) => void,
): AppThunk => async (dispatch) => {
  getDataSheetExportFile(String(id))
    .then((response) => {
      callback(response.url)
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}
